import { Button, makeStyles } from '@material-ui/core';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { apiClient } from '../../../../config/apiClient';
import UtilService from '../../../../helper/service';
import { createExperience } from '../../../../store/actions';
import { validateSessionCode } from '../../../../store/actions/creator/creatorExperienceBuilder';
import { BackDropAnalyzeLoading } from '../../../atoms/commonLoadings';
import CustomizedSnackbars from '../experienceManager/participantsDashboard/component/CustomSnackBar';
import roles from "../../../../helper/roles";

const useStyles = makeStyles(() => ({
  root: {
    padding: 20
  },
  title: {
    fontSize: 25,
    color: '#212d40',
    fontFamily: 'Spartan-bold',
  },
  note: {
    fontSize: 12,
    fontFamily: 'roboto-regular',
    color: '#212d40',
    fontStyle: 'italic'
  },
  guide: {
    marginTop: 8,
    color: '#212d40',
    fontSize: 15,
  },
  line: {
    width: '100%',
    height: 2,
    background: '#cdcdcd',
    margin: '27px 0'
  },
  title2: {
    fontSize: 17,
    fontFamily: 'roboto-bold',
    color: '#212d40'
  },
  btn1: {
    width: 120,
    height: 40,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 17,
    marginRight: 20,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  btn2: {
    width: 120,
    height: 40,
    borderRadius: 6,
    background: '#e0e0e0',
    color: '#444',
    textTransform: 'none',
    fontSize: 17,
  },
  icon: {
    width: 32,
    height: 32,
    marginLeft: 10
  },
  linkPanel: {
    fontSize: 40,
    fontFamily: 'roboto-black',
    color: '#697683',
    marginLeft: 20
  },
  addBtn: {
    width: 90,
    height: 35,
    textTransform: "unset",
    backgroundColor: '#F0F0F0',
    color: '#697683',
  },
  sharePane: {
    margin: "auto",
    display: "flex",
    alignItems: "center"
  },
  row: {
    display: 'flex',
    flexDirection: 'row'
  }
}));

function CreateAutomation() {

  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const { is_loading } = useSelector((state: any) => state.experience);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";

  const [snackAlertType, handleSnackAlertType] = useState('');
  const [snackAlertMsg, handleSnackMsg] = useState('');
  const [isShownSnackAlert, setShownSnackAlert] = useState(false);
  const [copied, setCopied] = useState(false);
  const [sessionCode, setSessionCode] = useState();

  const moderatedName = "Live Experience - " + moment().format("MM/DD");

  useEffect(() => {
    const getSessionCode = async () => {
      const payload = {
        "requestor": "experience",
        "tenant_id": loginUserData.customer_id
      };
      const res = await apiClient(false).post('/registration/v2/session/tokens', payload);
      if (res && res.data && res.data.token) {
        const checkSession = await validateSessionCode(apolloClient.client, res.data.token);
        if (checkSession && checkSession.data && checkSession.data.validateSessionCode) {
          setSessionCode(res.data.token);
          localStorage.setItem("session_code", String(res.data.token));
        } else {
          getSessionCode();
        }
      } else {
        getSessionCode();
      }
    };
    if (!sessionCode) {
      getSessionCode();
    }
  }, [dispatch, sessionCode, loginUserData.customer_id, apolloClient]);

  const hideSnackAlert = () => {
    setShownSnackAlert(false);
  }

  const onGoBack = () => {
    let url = '/creator/dashboard';
    if (UtilService.checkTrialAccess(loginUserData, roles['trial']['dashboard'])) {
      url = '/subscriber/creator/dashboard';
    }
    history.push(url);
  };

  const onStartExperience = () => {

    const request = {
      title: moderatedName,
      description: '',
      scheduled_start: new Date(),
      scheduled_end: UtilService.getEndDateMobileTime(new Date()),
      user_id: loginUserData.user_id,
      status: 'UPCOMING',
      type: 'MODERATED',
      agenda_json: {
        schedules: []
      },
      session_code: sessionCode,
      subcategory: "MEETING",
      category: "MEETINGS",
      participants: [],
      braintrust_id: null,
      braintrust_demo: false,
      hubs: []
    };

    dispatch(createExperience(apolloClient.client, request, () => {
      handleSnackMsg('Congratulations. Your event is LIVE!');
      handleSnackAlertType('success');
      setShownSnackAlert(true);
      setTimeout(()=> {onGoStart();}, 1000)
    }))
  }

  const onGoStart = () => {
    let url = '/creator/experience-manager/participants/' + sessionCode;
    if (UtilService.checkTrialAccess(loginUserData, roles['trial']['experiences'])) {
      url = '/subscriber/creator/experience-manager/participants/' + sessionCode;
    }
    history.push(url);
  };

  return (
    <div className={classes.root}>
      <BackDropAnalyzeLoading loading={is_loading} />

      <p className={classes.title}>
        Create a new Experience with just a tap.
      </p>

      <div className={classes.note}> {"We're autofilling some Experience details to make it easier on mobile."}(You can change these from your desktop or tablet later)</div>
      <br />
      <div className={classes.guide}><b>Experience Name:</b> {moderatedName}</div>
      <div className={classes.guide}><b>Start Time:</b> Now ({UtilService.getParticipantDate(new Date())})</div>
      <div className={classes.guide}><b>End Time:</b> {UtilService.getParticipantDate(UtilService.getEndDateMobileTime(new Date()))}</div>

      <div className={classes.line} />

      <div className={classes.title2}>Participants can join with Experience ID:</div>
      <br />

      <div className={classes.sharePane}>
        {sessionCode && <CopyToClipboard
          text={sessionCode}
          onCopy={() => {
            setCopied(true);
            handleSnackMsg('Link Copied');
            handleSnackAlertType('success');
            setShownSnackAlert(true);
          }}>
          <Button
            variant="contained"
            className={classes.addBtn}
            disabled={copied}
          >
            {copied ? 'Copied' : 'Copy'}
          </Button>
        </CopyToClipboard>}
        <div className={classes.linkPanel}>
          {sessionCode}
        </div>
      </div>

      <br />
      <div className={classes.note}>Tap the PLUS button at the top of the immersion app & enter the code.</div>
      <div className={classes.line} />

      <div className={classes.guide}>During the experience, from this web browser, you can add notes or manually STOP data collection on the Second-by-Second tab.</div>
      <br />

      <div className={classes.row}>
        {sessionCode && <div className={classes.btn1} onClick={onStartExperience}>
          Start
          <img src={'/assets/icons/arrow-right-circle.svg'} alt="{}" className={classes.icon} />
        </div>}
        <Button color='secondary' size='large' className={classes.btn2} onClick={onGoBack}>
          Cancel
        </Button>
      </div>

      <CustomizedSnackbars type={snackAlertType} message={snackAlertMsg} open={isShownSnackAlert} onClose={hideSnackAlert} />

    </div>

  )
}

export default CreateAutomation;